exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TripMetrics-628de281{padding:20px 0 18px 0}.TripMetrics-628de281 strong{font-weight:500}.TripMetrics-628de281 li{border:none}.TripMetrics-628de281 li:hover{border-color:transparent !important}.TripMetrics-628de281 li.hr-dd300054{height:1px;padding:0;margin:0;background:#E0E0E0}.TripMetrics-628de281 li.hr-dd300054:hover{padding:0 !important}.TripMetrics-628de281.showingSegment-f8829ffe strong{color:#6982FF}\n", ""]);

// Exports
exports.locals = {
	"TripMetrics": "TripMetrics-628de281",
	"hr": "hr-dd300054",
	"showingSegment": "showingSegment-f8829ffe"
};